import React, { useState, useEffect } from 'react';
import { OverviewTab } from '../components/tabs/OverviewTab';
import { StrainTab } from '../components/tabs/StrainTab';
import { SleepTab } from '../components/tabs/SleepTab';
import { RecoveryTab } from '../components/tabs/RecoveryTab';
import { ReadinessTab } from '../components/tabs/ReadinessTab';
import { HrvTab } from '../components/tabs/HrvTab';
import { useHealthMetrics } from '../hooks/useHealthMetrics';
import { useLocation } from 'react-router-dom';
import { TabContainer } from '../components/tabs/TabContainer';
import { TabHeader } from '../components/tabs/TabHeader';
import { Activity, Moon, Battery, Brain, Heart } from 'lucide-react';

export function HomePage() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('overview');
  const metrics = useHealthMetrics();

  useEffect(() => {
    const state = location.state as { tab?: string };
    if (state?.tab) {
      setActiveTab(state.tab);
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  const handleTabClose = () => {
    setActiveTab('overview');
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'strain':
        return (
          <TabContainer>
            <TabHeader 
              title="Strain Analysis" 
              icon={<Activity className="w-6 h-6 text-primary" />}
              onClose={handleTabClose}
            />
            <StrainTab metrics={metrics} onClose={handleTabClose} />
          </TabContainer>
        );
      case 'sleep':
        return (
          <TabContainer>
            <TabHeader 
              title="Sleep Analysis" 
              icon={<Moon className="w-6 h-6 text-primary" />}
              onClose={handleTabClose}
            />
            <SleepTab metrics={metrics} onClose={handleTabClose} />
          </TabContainer>
        );
      case 'recovery':
        return (
          <TabContainer>
            <TabHeader 
              title="Recovery Analysis" 
              icon={<Heart className="w-6 h-6 text-primary" />}
              onClose={handleTabClose}
            />
            <RecoveryTab metrics={metrics} onClose={handleTabClose} />
          </TabContainer>
        );
      case 'readiness':
        return (
          <TabContainer>
            <TabHeader 
              title="Readiness Analysis" 
              icon={<Battery className="w-6 h-6 text-primary" />}
              onClose={handleTabClose}
            />
            <ReadinessTab metrics={metrics} onClose={handleTabClose} />
          </TabContainer>
        );
      case 'hrv':
        return (
          <TabContainer>
            <TabHeader 
              title="HRV Analysis" 
              icon={<Heart className="w-6 h-6 text-primary" />}
              onClose={handleTabClose}
            />
            <HrvTab metrics={metrics} onClose={handleTabClose} />
          </TabContainer>
        );
      default:
        return <OverviewTab metrics={metrics} />;
    }
  };

  return (
    <div className="min-h-screen">
      <div className="pt-[3.5rem] sm:pt-0">
        {renderTabContent()}
      </div>
    </div>
  );
}